<form (ngSubmit)="save()" [formGroup]="ruleForm">
	<div [alarisLoading]="rulesService.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ rule.ruleId ? ('rules.edit' | translate) : ('rules.create' | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-input formControlName="name" [errors]="errors">
				{{ 'rules.name' | translate }}
			</alaris-input>

			<alaris-text-area [expandable]="true" [placeholder]="'gl.textAreaHint' | translate"
							  formControlName="prefixList"
							  #prefixListArea
							  maxHeight="none" mode="tag" [errors]="errors">
				{{ 'rules.prefix_list' | translate }}
			</alaris-text-area>

			<alaris-text-area [expandable]="true" [placeholder]="'gl.textAreaHint' | translate"
							  formControlName="senderList"
							  maxHeight="none" mode="tag">
				{{ 'rules.sender_list' | translate }}
			</alaris-text-area>

			<alaris-multi-select2 [alarisLoading]="sourcesService.loading$" [backdrop]="false"
								  [displayWith]="displayChoices.bind(this)"
								  [expandable]="true"
								  [label]="'rules.choice_list' | translate"
								  [optionsCount]="sources.length"
								  [showAllSelected]="true"
								  [separator]="separator"
								  formControlName="choiceList"
								  mode="tag" [errors]="errors">
				<alaris-select-filter2 [formControl]="sourcesFilter"></alaris-select-filter2>
				@for (source of sources; track source) {
					<alaris-multi-options2 [value]="source.SourceId">
						{{ source.Name }}
					</alaris-multi-options2>
				}
			</alaris-multi-select2>

			@if (ruleForm.controls.choiceList.value && ruleForm.controls.choiceList.value.length > 0) {
				<alaris-card (cdkDropListDropped)="drop($event)" cdkDropList class="choices" size="auto">
					@for (choice of ruleForm.controls.choiceList.value; track choice) {
						<alaris-card size="auto" class="choice text-ellipsis" cdkDrag>
							{{ (choice | source)?.Name }}
						</alaris-card>
					}
				</alaris-card>
			}

			<alaris-toggle [formControl]="inclusiveList">{{ 'rules.include_products' | translate }}</alaris-toggle>
			@if (inclusiveList.value) {
				@if (!eapiEnable) {
					<alaris-input formControlName="productList" [errors]="errors">
						{{ 'rules.product_list' | translate }}
					</alaris-input>
				} @else {
					<alaris-multi-select2 [alarisLoading]="productsService.loading$" [backdrop]="false"
										  [expandable]="true"
										  [label]="'rules.product_list' | translate"
										  [optionsCount]="products.length"
										  [displayWith]="displayProduct.bind(this)"
										  [showAllSelected]="true"
										  [separator]="separator"
										  formControlName="productList"
										  mode="tag"
										  [errors]="errors">
						<alaris-select-filter2 [formControl]="productsFilter"></alaris-select-filter2>
						@for (product of products; track product) {
							<alaris-multi-options2 [value]="product.product_id.toString()">{{ product.product_caption }}
								({{ product.acc_currency_code }})
								- {{ product.product_direction === 0 ? 'Client' : 'Vendor' }}</alaris-multi-options2>
						}
					</alaris-multi-select2>
				}
			}
			@if (!eapiEnable) {
				<alaris-input formControlName="productsNames" [errors]="errors">
					{{ 'rules.product_names' | translate }}
				</alaris-input>
			} @else {
				<alaris-select2 [label]="'rules.product_type' | translate"
								formControlName="productsType"
								[errors]="errors">
					@for (type of productNamesTypes; track type) {
						<alaris-options2 [value]="type">
							{{ type }}
						</alaris-options2>
					}
				</alaris-select2>

				<alaris-multi-select2 [alarisLoading]="sourcesService.loading$" [backdrop]="false"
									  [expandable]="true"
									  [label]="'rules.product_names' | translate"
									  [optionsCount]="productsNames.length"
									  [showAllSelected]="true"
									  formControlName="productsNames"
									  mode="tag" [errors]="errors">
					<alaris-select-filter2 [formControl]="productsNamesFilter"></alaris-select-filter2>
					@for (name of productsNames; track name) {
						<alaris-multi-options2 [value]="name">{{ name }}</alaris-multi-options2>
					}
				</alaris-multi-select2>
			}
			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'gl.reset' | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button [disabled]="ruleForm.invalid || (!ruleForm.dirty && !inclusiveList.dirty)"
					alaris-button bType="primary"
					size="lg"
					type="submit">
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ 'gl.submit' | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ 'actions.close' | translate }}
			</button>
		</div>
	</div>
</form>
